function renderTime(date) {
  const dateee = new Date(date).toJSON()
  return new Date(+new Date(dateee) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, " ")
    .replace(/\.[\d]{3}Z/, "")
}
/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018年09月23日
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式 返回年月日
 */
function formatWithChar(datetime) {
  if (datetime != null) {
    const dateMat = new Date(datetime)
    const year = dateMat.getFullYear()
    const month = dateMat.getMonth() + 1
    const day = dateMat.getDate()
    const hour = dateMat.getHours()
    const minute = dateMat.getMinutes()
    const second = dateMat.getSeconds()
    const timeFormat = addPreZero(year) + "年" + addPreZero(month) + "月" + addPreZero(day) + "日" + addPreZero(hour) + "时" + addPreZero(minute) + "分" + addPreZero(second) + "秒"

    return timeFormat
  }
  return ""
}
/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018年09月23日
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式 返回年月日
 */
function formatWithCharShort(datetime) {
  if (datetime != null) {
    const dateMat = new Date(datetime)
    const year = dateMat.getFullYear()
    const month = dateMat.getMonth() + 1
    const day = dateMat.getDate()
    const timeFormat = addPreZero(year) + "年" + addPreZero(month) + "月" + addPreZero(day) + "日"
    return timeFormat
  }
  return ""
}
/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018-09-23
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式 返回年月日
 */
function formatDate(datetime) {
  if (datetime != null) {
    const dateMat = new Date(datetime)
    const year = dateMat.getFullYear()
    const month = dateMat.getMonth() + 1
    const day = dateMat.getDate()
    const timeFormat = addPreZero(year) + "-" + addPreZero(month) + "-" + addPreZero(day)
    return timeFormat
  }
  return ""
}
function formatYear(datetime) {
  if (datetime != null) {

    const dateMat = new Date(datetime)
    const year = dateMat.getFullYear()
    const month = dateMat.getMonth() + 1
    const day = dateMat.getDate()
    const timeFormat = addPreZero(year) + '年'

    return timeFormat
  }
  return ""
}
/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018-09-23
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式 返回年月日
 */
function formatNowTime(datetime) {
  if (datetime != null) {
    const dateMat = new Date(datetime)
    const year = dateMat.getFullYear()
    const month = dateMat.getMonth() + 1
    const day = dateMat.getDate()
    const hour = dateMat.getHours()
    const minute = dateMat.getMinutes()
    const second = dateMat.getSeconds()
    const timeFormat = addPreZero(year) + "-" + addPreZero(month) + "-" + addPreZero(day) + " " + addPreZero(hour) + ":" + addPreZero(minute) + ":" + addPreZero(second)
    return timeFormat
  }
  return ""
}
function addPreZero(num) {
  if (num < 10) {
    return `0${num}`
  }
  return num
}
// 文档流 下载  注意请求接口的数据返回类型要是blob
function downloadFile(res, name, type) {
  if ("msSaveOrOpenBlob" in navigator) {
    // 判断是ie的浏览器，调用ie文件下载的方法
    const blob = new Blob([res])
    const title = name
    window.navigator.msSaveOrOpenBlob(blob, title)
  }
  const blob = new Blob([res])
  const downloadElement = document.createElement("a")
  const href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href

  downloadElement.download = name // 下载后文件名
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}
function download() {
  const xmlResquest = new XMLHttpRequest()
  xmlResquest.open("POST", "/eksoft/fileUpload/download", true)
  xmlResquest.setRequestHeader("Content-type", "application/json")
  xmlResquest.setRequestHeader("Authorization", "Bearer 6cda86e3-ba1c-4737-972c-f815304932ee")
  xmlResquest.responseType = "blob"
  xmlResquest.onload = function(oEvent) {
    const content = xmlResquest.response
    const elink = document.createElement("a")
    elink.download = "test.xlsx"
    elink.style.display = "none"
    const blob = new Blob([content])
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    document.body.removeChild(elink)
  }
  xmlResquest.send()
}
// 获取当前月份的第一天
function getCurrentMonthFirst() {
  var date = new Date()
  date.setDate(1)
  var month = parseInt(date.getMonth() + 1)
  var day = date.getDate()
  if (month < 10) {
    month = "0" + month
  }
  if (day < 10) {
    day = "0" + day
  }
  return date.getFullYear() + "-" + month + "-" + day
}

// 获取当前月份的最后一天
function getCurrentMonthLast(time) {
  var date = new Date(time)
  var currentMonth = date.getMonth()
  var nextMonth = ++currentMonth
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(nextMonthFirstDay - oneDay)
  // var month = parseInt(lastTime.getMonth()+1);
  var month = parseInt(lastTime.getMonth())
  var day = lastTime.getDate()
  /*  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }*/
  // return date.getFullYear() + '-' + month + '-' + day;
  return new Date(date.getFullYear(), month, day)
}
// 计算两个时间相差的天数
function datedifference(sDate1, sDate2) {
  //sDate1和sDate2是2006-12-18格式
  var dateSpan, dateFirst, dateSecond, iDays
  dateFirst = new Date(sDate1).getTime()
  dateSecond = new Date(sDate2).getTime()
  dateSpan = dateSecond - dateFirst
  dateSpan = Math.abs(dateSpan)
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
  return iDays
}

export { renderTime, downloadFile, formatWithChar, formatWithCharShort, formatDate, formatNowTime, addPreZero, getCurrentMonthLast, getCurrentMonthFirst, datedifference ,formatYear }
